import React from "react";
import { Link, Box } from "@chakra-ui/core";
import LinkType from "./linkType";
import {
  FiFacebook, FiInstagram, FiLink2, FiYoutube, FiTwitter, FiMail, FiPhone,
} from "react-icons/fi";
import {
  FaWhatsapp,
} from "react-icons/fa";

const ICONS = {
  facebook: {
    Icon: FiFacebook,
    color: "facebook.500",
  },
  instagram: {
    Icon: FiInstagram,
    color: "purple.500",
  },
  sharethis: {
    Icon: FiLink2,
    color: "blue.500",
  },
  youtube: {
    Icon: FiYoutube,
    color: "red.500",
  },
  twitter: {
    Icon: FiTwitter,
    color: "twitter.500",
  },
  email: {
    Icon: FiMail,
    color: "orange.500",
  },
  phone: {
    Icon: FiPhone,
    color: "green.500",
  },
  whatsapp: {
    Icon: FaWhatsapp,
    color: "whatsapp.500",
  },
};

const LinkItem = ({ link, ...rest }) => {
  const { Icon, color } = ICONS[link.type] || ICONS.sharethis;
  const url = `${link.type === 'email' ? 'mailto:' : ''}${link.url}`;
  return (
    <Link d="inline-block" href={url} isExternal {...rest}>
      <Box d="inline" as={Icon} color={color} mr={1} />
      {link.label}
    </Link>
  );
};

LinkItem.propTypes = {
  link: LinkType.isRequired,
};

export default LinkItem;
